import { api } from 'utils';
import { ListSubmitPayload } from '../ListZero.types';

export async function submitListZeroApi(payload: ListSubmitPayload) {
  return api().post('/list/submit', payload);
}
